<template>
    <div class="hospitalizations-table">
        <!-- FORM -->
        <div class="d-flex p-2 mt-4">
            <h5 class="fw-bold my-auto">Hospitalizations/Emergency Department Encounters</h5>
            <button
                slot="list-header"
                type="button"
                class="btn btn-primary ms-auto"
                @click="openAddHospitalization()"
                v-if="!isAddRequested"
            >
                Add Hospitalization/ED Encounter
            </button>
        </div>
        <div
            v-if="isAddRequested"
            :class="`card px-lg-5 py-2 mb-2 w-100 h-100 animated ${
                isAddRequested ? 'faster fadeInDown' : 'slow fadeOutUp'
            }`"
        >
            <HospitalAdmissionForm
                :hospitalization="newHospitalization"
                :cancel-hospitalization="cancelAddHospitalization"
                :save-hospitalization="saveHospitalization"
                :is-loading="isSaving"
                :is-new="true"
                :provider-id="providerId"
                :roles="roles"
                :patient-info="patientInfo"
                :application="application"
                :accountId="accountId"
            />
        </div>

        <!-- LIST -->
        <Pagination ref="paginationInstance" :page-changed="pageChangedCallback" :is-loading="isLoading">
            <table class="table table-responsive-md border border-gray">
                <thead>
                    <tr class="bg-table-header">
                        <th>Date Range</th>
                        <th>Diagnoses</th>
                        <th>Discharged To</th>
                        <th>Comments</th>
                        <th>ED Encounter</th>
                        <th class="text-end">Actions</th>
                    </tr>
                </thead>

                <tbody>
                    <!-- LOADING -->
                    <template v-if="isLoading">
                        <tr v-for="i of loadingCount" class="table-loading">
                            <td v-for="i of columns">
                                <span class="shimmer-loading"></span>
                            </td>
                        </tr>
                    </template>
                    <!-- NO RESULTS -->
                    <tr v-if="!isLoading && !isError && !hasData" class="table-empty">
                        <td :colspan="columns">
                            <h3>No Hospitalizations to Display</h3>
                        </td>
                    </tr>
                    <!-- ERROR -->
                    <tr v-if="!isLoading && isError" class="table-error">
                        <td :colspan="columns">
                            <ErrorMessageHandler title="Hospitalizations" :try-again="reset" />
                        </td>
                    </tr>
                </tbody>
                <template v-if="!isLoading && !isError && hasData">
                    <HospitalizationsRow
                        v-for="(hospitalization, index) of page.Items"
                        :hospitalization="hospitalization"
                        :columns="columns"
                        :index="index"
                        :page-reset="reset"
                        :patient-id="patientId"
                        :provider-id="providerId"
                        :roles="roles"
                        :patient-info="patientInfo"
                        :accountId="accountId"
                        :handleCancelEditHospitalization="handleCancelEditHospitalization"
                        :application="application"
                    />
                </template>
            </table>
        </Pagination>
    </div>
</template>

<style src="./HospitalizationsTable.scss" />
<script lang="ts" src="./HospitalizationsTable.ts" />
